const productdetailsar = {

description: "الوصف",
qtyWeight: "الكمية",
in: "في",
soldOut: "نفذت الكمية",
outOfStock: "غير متوفر",
addToCart: "أضف للسلة",
addToOrder: "أضف للطلب",
qty: "الكمية",
available: "متوفر",
category: "الفئة",
supplier: "المورد",
countryOfOrigin: "بلد المنشأ",
shareWithFriends: "شارك مع الأصدقاء",
dailyOffer: "عرض اليوم",
freshOrganicOffer: "أطعمة عضوية طازجة حتى خصم 65%",
shopNow: "تسوق الآن",
information: "المعلومات",
reviews: "التقييمات",
unit: "الوحدة",
stock: "المخزون",
noReviews: "لا توجد تقييمات بعد"

};

export default productdetailsar;